// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2zZKG","insightsList":"newBusinessInsightsMenu_insightsList__fBOFv","active":"newBusinessInsightsMenu_active__Dlbm3"};